import { render, staticRenderFns } from "./TotalOrderLogsPopup.vue?vue&type=template&id=bb6b2ace"
import script from "./TotalOrderLogsPopup.vue?vue&type=script&lang=js"
export * from "./TotalOrderLogsPopup.vue?vue&type=script&lang=js"
import style0 from "./TotalOrderLogsPopup.vue?vue&type=style&index=0&id=bb6b2ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports